import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const LOGO = "https://customer-assets-rejwkqb3.emergentagent.net/job_guest-retreat-finder/artifacts/ymwgc3ta_Logo%20Quattro%20Accommodations.png";

export default function PublicFooter() {
  const { t } = useLang();
  return (
    <footer className="bg-brand-violet text-white/80 mt-24" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <img src={LOGO} alt="Quattro Accommodations" className="h-10 w-auto object-contain bg-white/95 rounded-lg p-1.5 mb-4" />
          <p className="text-sm leading-relaxed text-white/60">{t("footer.tagline")}</p>
        </div>

        <div>
          <h4 className="text-white font-sans font-semibold text-sm uppercase tracking-wider mb-4">{t("footer.explore")}</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/case-vacanze" className="hover:text-brand-teal transition-colors">{t("nav.case")}</Link></li>
            <li><Link to="/proprietari" className="hover:text-brand-teal transition-colors">{t("footer.becomeHost")}</Link></li>
            <li><Link to="/prezzi" className="hover:text-brand-teal transition-colors">{t("nav.prices")}</Link></li>
            <li><Link to="/faq" className="hover:text-brand-teal transition-colors">{t("nav.faq")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-sans font-semibold text-sm uppercase tracking-wider mb-4">{t("footer.legal")}</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/privacy-policy" className="hover:text-brand-teal transition-colors">{t("footer.privacy")}</Link></li>
            <li><Link to="/cookie-policy" className="hover:text-brand-teal transition-colors">{t("footer.cookie")}</Link></li>
            <li><Link to="/termini-e-condizioni" className="hover:text-brand-teal transition-colors">{t("footer.terms")}</Link></li>
            <li><Link to="/contatti" className="hover:text-brand-teal transition-colors">{t("footer.contact")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-sans font-semibold text-sm uppercase tracking-wider mb-4">{t("footer.contactTitle")}</h4>
          <ul className="space-y-2.5 text-sm">
            <li className="flex items-center gap-2"><Mail size={15} className="text-brand-teal" /> info@quattro.house</li>
            <li className="flex items-center gap-2"><Phone size={15} className="text-brand-teal" /> +39 3334975115</li>
            <li className="flex items-start gap-2"><MapPin size={15} className="text-brand-teal shrink-0 mt-0.5" /> Via L. Cavaliero 92, Salerno 84125</li>
            <li className="text-white/50 pt-1">P. IVA 05992520659</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Quattro Accommodations · P. IVA 05992520659. {t("footer.rights")}</span>
          <span className="font-mono">{t("footer.motto")}</span>
        </div>
      </div>
    </footer>
  );
}
